var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative"},[_c('div',{staticClass:"absolute flex-column h6 p1 ml1 rounded",attrs:{"id":_vm.tooltipId}}),_c('div',{staticClass:"col-12",attrs:{"id":_vm.svgId}})])}
var staticRenderFns = []

export { render, staticRenderFns }